import React, { useEffect, useState, useRef } from "react";
import { MDBModal, MDBModalBody, MDBModalHeader } from "mdbreact";
import { useDispatch, useSelector } from "react-redux";
import UploadIcon from "assets/images/icons/Featured icon.png";
import IFCIMG from "assets/images/newLanding/image 245.png";
import RevitImg from "assets/images/newLanding/revit 1(1).png";
import StepDoneImg from "assets/images/icons/_Step icon base.png";
import StepInProgressImg from "assets/images/icons/Content.png";
import StepIncompleteImg from "assets/images/icons/Content1.png";
import SuccessIMG from "assets/images/icons/success.png";
import { Maybe } from "helpers/maybeFunctor";
import { createBrandSettings } from "api/brands/brandSettings";

import Loading from "../../components/ui-components/loading";

import {
  createBrandNew as createBrand,
} from "api/brands/createBrand";
import { getStatuses } from "api/milestones/getMilestones";
import addNotification from "helpers/notify";
import { choseToggle } from "helpers/toggleIfLoading";
import { useHttp } from "hooks/useHttp";
import { addNewBrand } from "../../actions/user";

import Select from "react-select";
import "../../components/CreateBrandModal/CreateModal.scss";
import { uploadFileToServer } from "components/uploadFile/uploadFile";
import { getBrandSettings } from "api/brands/brandSettings";

import { useForm } from "react-hook-form";
import { getCompanySettings } from "api/companySettings/getCompanySettings";
import { verifyBrandName } from "api/brands/verifyBrandName";
import { debounce } from "lodash";

const AddbrandAdmin = (props) => {
  var milestoneOptionsVar = [];
  const {
    register,
    formState: { errors },
    trigger,
    reset,
    setError,
  } = useForm({ mode: "onChange" });
  const dispatch = useDispatch();
  const companiesRedux = useSelector((s) => s.superAdmin);

  const brandImgInputRef = useRef(null);
  const ifcFileInputRef = useRef(null);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [brandImage, setBrandImage] = useState(null);
  const [brandNumber, setBrandNumber] = useState("");

  const [ifcFile, setIfcFile] = useState(null);
  const [ifcUrl, setIfcUrl] = useState("");

  const [teamMembers, setTeamMembers] = useState([]);
  const [isParent, setIsParent] = useState(false);
  const [selectAllAvaialable, setSelectAllAvaialable] = useState(false);
  const [selectAllSelected, setSelectAllSelected] = useState(false);
  const [brandNumberLoading, setBrandNumberLoading] = useState(false);

  const [brandOwner, setBrandOwner] = useState([]);

  useEffect(() => {
    console.log(companiesRedux);
  }, []);

  const companyData = companiesRedux?.company?.find(
    (item) => item?._id === props?.data?._id
  );
  const companyUserData = companiesRedux?.all_users?.filter(
    (item) => item?.company === props?.data?._id
  );

  //   const FilterteamMembers = Maybe.of(companyData?.users).map((users) => {
  //     return users?.filter((user) => user.email !== emailRedux);
  //   });

  const teamMembersOptions = companyData?.users?.map((i) => ({
    label: i.name,
    value: i._id,
  }));

  const brandOwnerOptions = companyUserData?.map((i) => ({
    label: i.name,
    value: i._id,
  }));

  const parentBrandOptions = props?.parents?.map((i) => ({
    label: i.title,
    value: i._id,
  }));
  const [parentBrand, setParentBrand] = useState("");

  const PROJ_TYPES = {
    REVIT: "REVIT",
    IFC: "IFC",
  };

  const STEP = {
    BRAND_SELECTION: "BRAND_SELECTION",
    STEP_01: "STEP_01",
    STEP_02: "STEP_02",
    STEP_03: "STEP_03",
    STEP_04: "STEP_04",
  };

  const [selectedBrandType, setSelectedBrandType] = useState(
    PROJ_TYPES.REVIT
  );
  const [selectedSteps, setSelectedSteps] = useState(STEP.BRAND_SELECTION);
  const [milestones, setMilestones] = useState([]);
  const [milestonesOptions, setMilestonesOptions] = useState([]);

  const [includeMiscellaneous, setIncludeMiscellaneous] = useState(false);
  const [include2DElements, setInclude2DElements] = useState(false);

  const createObjectForm = {};

  useEffect(() => {
    // (async () => {
    //   (async () => {
    //     const res1 = await getStatuses(props?.data?._id);
    //     milestoneOptionsVar = res1?.map((i) => ({
    //       label: i.key,
    //       value: i._id,
    //     }));
    //     setMilestonesOptions(milestoneOptionsVar);
    //     getCompanySettingsAPI(props?.data?._id);
    //   })();
    // })();
  }, []);

  // on Click close reset form
  const toggle = () => {
    props.toggle();
    setTitle("");
    setDescription("");
    setBrandImage(null);
    setIfcFile(null);
    setTeamMembers([]);
    setIsParent(false);
    setParentBrand("");
    setSelectedBrandType(PROJ_TYPES.REVIT);
    setSelectedSteps(STEP.BRAND_SELECTION);
    reset();
  };

  const { loading, request: createBrandAPI } = useHttp({
    requestCallback: (data) => createBrand(data),
    onLoad: (res) => {
      dispatch(addNewBrand(res));
      addNotification("Brand was successfully created!", "success");
      setSelectedSteps(STEP.STEP_04);
    },
    onError: (res) => {
      addNotification(
        "Something went wrong while creating your brand, please contact support.",
        "danger"
      );
    },
  });

  const {
    loading: exportsettingsloading,
    request: createBrandSettingsAPI,
  } = useHttp({
    requestCallback: (data) => createBrandSettings(data),
    onLoad: (res) => {
      createObjectForm.brandExportSettings = res?._id;
      createBrandAPI(createObjectForm);
    },
    onError: (res) => {
      addNotification(
        "Something went wrong while creating your brand, please contact support.",
        "danger"
      );
    },
  });


  const { request: getCompanySettingsAPI } = useHttp({
    requestCallback: (data) => getCompanySettings(data),
    onLoad: (res) => {
      getBrandSettingsAPI(res?.recentBrandSettings);
    },
    onError: (res) => {},
  });

  const { loading: exportSettingsLoading, request: getBrandSettingsAPI } =
    useHttp({
      requestCallback: (data) => getBrandSettings(data),
      onLoad: (res) => {
        console.log(res);
        setMilestones(
          milestoneOptionsVar?.find((i) => i.value === res?.milestone)
        );
        setIncludeMiscellaneous(res?.includeMiscellaneous);
        setInclude2DElements(res?.include2DElements);

      },
      onError: (res) => {},
    });

  const [imageUploadLoading, setImageUploadLoading] = useState(false);

  const createObject = async (e) => {
    e.preventDefault();
    createObjectForm.user = brandOwner?.value
    createObjectForm.companyId = props?.data?._id;
    createObjectForm.title = title;
    createObjectForm.brandNumber = brandNumber;

    createObjectForm.description = description;

    if (brandImage) {
      setImageUploadLoading(true);
      var fileUrl;
      fileUrl = await uploadFileToServer(brandImage);
      setImageUploadLoading(false);
    }

    createObjectForm.img = fileUrl;

    createObjectForm.users = teamMembers?.map((i) => i.value);
    createObjectForm.isParent = isParent;
    if (!isParent) {
      createObjectForm.parentBrandID = parentBrand?.value;
    }
    if (selectedBrandType === PROJ_TYPES.IFC) {
      createObjectForm.isIfcBrand = true;
      createObjectForm.masterFile = `${"uploads/"}${ifcUrl}`;
    }

    if (selectedBrandType === PROJ_TYPES.REVIT) {
      createObjectForm.isIfcBrand = false;
    }

    createObjectForm.milestone = milestones?.value;
    createObjectForm.includeMiscellaneous = includeMiscellaneous;
    createObjectForm.include2DElements = include2DElements;

    const res = await createBrandSettingsAPI(createObjectForm);
  };

  const handleBrandImg = async (e) => {
    const selectedImg = e.target.files[0];
    setBrandImage(selectedImg);
  };

  const handleIfcFile = async (e) => {
    const selectedIfc = e.target.files[0];
    setIfcFile(selectedIfc);
    const fileUrl = await uploadFileToServer(selectedIfc);
    setIfcUrl(fileUrl);
  };

  const checkBrandNumber = async (value) => {
    setBrandNumberLoading(true);
    try {
      const res = await verifyBrandName({ name: value });
      setBrandNumberLoading(false);
      if (res.isBrandNameUnique) {
        setBrandNumber(value);
      } else {
        setError("brandNo", { type: "custom", message: res.err });
        setBrandNumber("");
      }
    } catch (error) {
      setError("brandNo", { type: "custom", message: error.err });
      setBrandNumber("");
      setBrandNumberLoading(false);
    }
  };

  const debouncedApiCall = debounce(checkBrandNumber, 1000);

  return (
    <MDBModal
      isOpen={props.isOpen}
      toggle={choseToggle(loading, toggle)}
      centered
      className="create-modal-full-size"
    >
      <MDBModalHeader toggle={choseToggle(loading, toggle)}>
        Create brand
      </MDBModalHeader>
      <MDBModalBody className="pt-0">
        <form onSubmit={(e) => createObject(e)}>
          {selectedSteps === STEP.BRAND_SELECTION ? (
            <div>
              <div className="text-center mt-5 text-black">
                <p className="inter f-14 font-weight-bold mb-1">Brand type</p>
                <p className="inter f-14 font-weight-normal">
                  Please Select your brand type
                </p>
              </div>

              <div className="d-flex gap-15 mt-5">
                <div
                  className={`${"cursor-pointer"} ${
                    selectedBrandType === PROJ_TYPES.REVIT
                      ? "select-proj-box-active"
                      : "select-proj-box"
                  }`}
                  onClick={() => setSelectedBrandType(PROJ_TYPES.REVIT)}
                >
                  <img src={RevitImg} alt="" />
                  <div>
                    <p className="f-14 inter font-weight-bold mb-1 text-black">
                      Revit
                    </p>
                    <p className="f-14 inter font-weight-normal mb-0 text-black">
                      Revit is a commercial building information modeling (BIM)
                      software by the company Autodesk.
                    </p>
                  </div>
                </div>
                <div
                  className={`${"cursor-pointer"} ${
                    selectedBrandType === PROJ_TYPES.IFC
                      ? "select-proj-box-active"
                      : "select-proj-box"
                  }`}
                  onClick={() => setSelectedBrandType(PROJ_TYPES.IFC)}
                >
                  <img src={IFCIMG} alt="" />
                  <div>
                    <p className="f-14 inter font-weight-bold mb-1 text-black">
                      IFC
                    </p>
                    <p className="f-14 inter font-weight-normal mb-0 text-black">
                      IFC is short for International Foundation Class and files
                      using the IFC file format are Building Information
                      Modelling (BIM) files.
                    </p>
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-between mt-5">
                <button
                  className="header-btn text-bid border-bid"
                  type="button"
                  onClick={() => toggle()}
                >
                  Cancel
                </button>
                <button
                  className="header-btn text-white bg-bid border-bid mr-0"
                  onClick={() => setSelectedSteps(STEP.STEP_01)}
                  type="button"
                >
                  Next
                  <span className="ml-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="8"
                      height="12"
                      viewBox="0 0 8 12"
                      fill="none"
                    >
                      <path
                        d="M4.97633 6.00058L0.851562 1.87577L2.03007 0.697266L7.33341 6.00058L2.03007 11.3038L0.851562 10.1253L4.97633 6.00058Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                </button>
              </div>
            </div>
          ) : (
            <div>
              {selectedSteps !== STEP.STEP_04 && (
                <div className="stepper-div">
                  <div className="step-01">
                    {selectedSteps === STEP.STEP_01 && (
                      <img src={StepInProgressImg} alt="" />
                    )}
                    {selectedSteps === STEP.STEP_02 && (
                      <img src={StepDoneImg} alt="" />
                    )}
                    {selectedSteps === STEP.STEP_03 && (
                      <img src={StepDoneImg} alt="" />
                    )}
                    <p className="inter f-14 font-weight-bold mb-1">Step 01</p>
                    <p className="inter f-14 font-weight-normal">Basic info</p>
                  </div>
                  <div className="step-03">
                    {selectedSteps === STEP.STEP_01 && (
                      <img src={StepIncompleteImg} alt="" />
                    )}
                    {selectedSteps === STEP.STEP_02 && (
                      <img src={StepIncompleteImg} alt="" />
                    )}
                    {selectedSteps === STEP.STEP_03 && (
                      <img src={StepInProgressImg} alt="" />
                    )}
                    <p className="inter f-14 font-weight-bold mb-1">Step 03</p>
                    <p className="inter f-14 font-weight-normal">
                      Export settings
                    </p>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Step 01 */}
          {selectedSteps === STEP.STEP_01 ? (
            <>
              <div className="d-flex justify-content-between gap-2">
                <div className="form-group mt-3 w-50">
                  <label
                    htmlFor=""
                    className="f-14 inter text-black font-weight-500"
                  >
                    Title <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Brand title"
                    {...register("title", {
                      required: "Brand title is required",
                      maxLength: 20,
                      onChange: (e) => setTitle(e.target.value),
                    })}
                  />
                  {errors.title && (
                    <p role="alert" className="validation-error-msg">
                      {errors.title.message}
                    </p>
                  )}
                </div>
                <div className="form-group mt-3 w-50">
                  <label
                    htmlFor=""
                    className="f-14 inter text-black font-weight-500"
                  >
                    Brand Number <span className="text-danger">*</span>
                  </label>
                  <div className="position-relative">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Brand Number"
                      {...register("brandNo", {
                        required: "Brand Number is required",
                        maxLength: 20,
                        onChange: (e) => debouncedApiCall(e.target.value),
                      })}
                    />
                    {brandNumberLoading && (
                      <i className="fa fa-spinner small-spinner input-box-spinner" />
                    )}
                  </div>
                  {errors.brandNo && (
                    <p role="alert" className="validation-error-msg">
                      {errors.brandNo.message}
                    </p>
                  )}
                </div>
              </div>

              <div className="form-group mt-3">
                <label
                  htmlFor=""
                  className="f-14 inter text-black font-weight-500"
                >
                  Description
                </label>
                <textarea
                  onChange={(e) => setDescription(e.target.value)}
                  type="text"
                  className="form-control"
                  placeholder="Description"
                ></textarea>
              </div>

              {selectedBrandType === PROJ_TYPES.IFC && (
                <div className="form-group mt-3">
                  <label
                    htmlFor=""
                    className="f-14 inter text-black font-weight-500"
                  >
                    IFC file
                  </label>
                  <div className="d-flex align-items-center justify-content-between">
                    <div
                      className="profile-upload-box cursor-pointer w-fill d-flex align-items-center my-0 justify-content-between"
                      onClick={() => ifcFileInputRef.current.click()}
                    >
                      <div className="text-left">
                        {ifcFile ? (
                          ifcFile.name
                        ) : (
                          <p className="font-weight-bold text-black f-14">
                            Click to upload{" "}
                            <span className="font-weight-light">
                              or drag and drop
                            </span>
                          </p>
                        )}
                        <p className="f-12">.IFC</p>
                      </div>
                      <img src={UploadIcon} className="upload-icon" />
                    </div>
                  </div>
                  <input
                    ref={ifcFileInputRef}
                    onChange={handleIfcFile}
                    type="file"
                    id="ifcFile"
                    name="ifcFile"
                    accept={".ifc"}
                    style={{ display: "none" }}
                  />
                </div>
              )}

              <div className="form-group mt-3">
                <label
                  htmlFor=""
                  className="f-14 inter text-black font-weight-500"
                >
                  Brand image
                </label>
                <div className="d-flex align-items-center justify-content-between">
                  <div
                    className="profile-upload-box cursor-pointer w-fill d-flex align-items-center my-0 justify-content-between"
                    onClick={() => brandImgInputRef.current.click()}
                  >
                    <div className="text-left">
                      <p className="font-weight-bold text-black f-14">
                        Click to upload{" "}
                        <span className="font-weight-light">
                          or drag and drop
                        </span>
                      </p>
                      <p className="f-12">
                        SVG, PNG, JPG or GIF (max. 800x400px)
                      </p>
                    </div>
                    <img src={UploadIcon} className="upload-icon" />
                  </div>
                  <img
                    src={
                      brandImage
                        ? window.URL.createObjectURL(brandImage)
                        : UploadIcon
                    }
                    className="uploaded-icon"
                  />
                </div>

                <input
                  ref={brandImgInputRef}
                  onChange={handleBrandImg}
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                />
              </div>

              {/* <div className="d-flex justify-content-between">
                <div className="form-group mt-3 w-49">
                  <label
                    htmlFor=""
                    className="f-14 inter text-black font-weight-500"
                  >
                    Start Date
                  </label>
                  <input
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    type="date"
                    className="form-control"
                  />
                </div>
                <div className="form-group mt-3 w-49">
                  <label
                    htmlFor=""
                    className="f-14 inter text-black font-weight-500"
                  >
                    End Date
                  </label>
                  <input
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    type="date"
                    className="form-control"
                  />
                </div>
              </div> */}

              <div className="form-group-div mt-3">
                <label className="f-14 inter text-black font-weight-500">
                  Admin Brand Owner
                </label>
                <Select
                  options={brandOwnerOptions}
                  onChange={(options) => setBrandOwner(options)}
                />
              </div>

              <div className="form-group-div mt-3">
                <label className="f-14 inter text-black font-weight-500">
                  Team member
                </label>
                <Select
                  options={teamMembersOptions}
                  isMulti
                  onChange={(options) => setTeamMembers(options)}
                />
              </div>

              <div className="form-check form-switch ml-1 mt-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckChecked"
                  value={isParent}
                  onChange={(e) => setIsParent(e.target.checked)}
                  checked={isParent}
                />
                <label
                  className="form-check-label ml-2 f-14 inter text-black font-weight-500"
                  htmlFor="flexSwitchCheckChecked"
                >
                  Parent Brand
                </label>
              </div>

              {!isParent && (
                <div className="form-group-div mt-3">
                  <label className="f-14 inter text-black font-weight-500">
                    Select Parent
                  </label>
                  <Select
                    options={parentBrandOptions}
                    onChange={(e) => setParentBrand(e)}
                  />
                </div>
              )}

              <div className="d-flex align-items-center justify-content-between mt-5">
                <button
                  type="button"
                  className="header-btn text-bid border-bid"
                  onClick={() => setSelectedSteps(STEP.BRAND_SELECTION)}
                >
                  <span className="mr-3 transform-180">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="8"
                      height="12"
                      viewBox="0 0 8 12"
                      fill="none"
                    >
                      <path
                        d="M4.97633 6.00058L0.851562 1.87577L2.03007 0.697266L7.33341 6.00058L2.03007 11.3038L0.851562 10.1253L4.97633 6.00058Z"
                        fill="#09121F"
                      />
                    </svg>
                  </span>
                  Back
                </button>
                <button
                  type="button"
                  className="header-btn text-white bg-bid border-bid mr-0"
                  // disabled={title.length === 0}
                  onClick={(e) => {
                    if (title.length === 0) {
                      trigger(["title"]);
                    } else if (brandNumber.length === 0) {
                      trigger(["brandNo"]);
                    } else {
                      selectedBrandType === PROJ_TYPES.IFC && !ifcFile
                        ? alert("Please upload a IFC/Zip file")
                        : setSelectedSteps(STEP.STEP_03);
                    }
                  }}
                >
                  Next
                  <span className="ml-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="8"
                      height="12"
                      viewBox="0 0 8 12"
                      fill="none"
                    >
                      <path
                        d="M4.97633 6.00058L0.851562 1.87577L2.03007 0.697266L7.33341 6.00058L2.03007 11.3038L0.851562 10.1253L4.97633 6.00058Z"
                        fill="white"
                      />
                    </svg>
                  </span>
                </button>
              </div>
            </>
          ) : null}

          {/* Step 02 only htmlFor Revit*/}
          {selectedSteps === STEP.STEP_02 ? (
            <>
              {selectedBrandType === PROJ_TYPES.REVIT ? (
                <>
                  {/* Revit parameter picker removed — BidLight legacy, no parameters in Prigmar. */}

                  <div className="d-flex align-items-center justify-content-between mt-5">
                    <button
                      type="button"
                      className="header-btn text-bid border-bid"
                      onClick={() => setSelectedSteps(STEP.STEP_01)}
                    >
                      <span className="mr-3 transform-180">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="8"
                          height="12"
                          viewBox="0 0 8 12"
                          fill="none"
                        >
                          <path
                            d="M4.97633 6.00058L0.851562 1.87577L2.03007 0.697266L7.33341 6.00058L2.03007 11.3038L0.851562 10.1253L4.97633 6.00058Z"
                            fill="#09121F"
                          />
                        </svg>
                      </span>
                      Back
                    </button>
                    <button
                      type="button"
                      className="header-btn text-white bg-bid border-bid mr-0"
                      onClick={() => setSelectedSteps(STEP.STEP_03)}
                    >
                      Next
                      <span className="ml-3">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="8"
                          height="12"
                          viewBox="0 0 8 12"
                          fill="none"
                        >
                          <path
                            d="M4.97633 6.00058L0.851562 1.87577L2.03007 0.697266L7.33341 6.00058L2.03007 11.3038L0.851562 10.1253L4.97633 6.00058Z"
                            fill="white"
                          />
                        </svg>
                      </span>
                    </button>
                  </div>
                </>
              ) : null}
            </>
          ) : null}

          {/* Step 03*/}
          {selectedSteps === STEP.STEP_03 ? (
            <>
              {exportSettingsLoading && (
                <Loading color="dark" text="Creating..." />
              )}
              <div className="form-group-div mt-3">
                <label className="f-14 inter text-black font-weight-500">
                  Status
                </label>
                <Select
                  options={milestonesOptions}
                  onChange={(options) => setMilestones(options)}
                  defaultValue={milestones}
                />
              </div>

              <div className="form-check form-switch ml-1 mt-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="includeMiscellaneous"
                  checked={includeMiscellaneous}
                  onChange={(e) => setIncludeMiscellaneous(e.target.checked)}
                />
                <label
                  className="form-check-label ml-2 f-14 inter text-black font-weight-500"
                  htmlFor="includeMiscellaneous"
                >
                  Include Miscellaneous
                </label>
              </div>

              <div className="form-check form-switch ml-1 mt-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="include2DElements"
                  checked={include2DElements}
                  onChange={(e) => setInclude2DElements(e.target.checked)}
                />
                <label
                  className="form-check-label ml-2 f-14 inter text-black font-weight-500"
                  htmlFor="include2DElements"
                >
                  Include 2D Elements
                </label>
              </div>

              {loading ? <Loading color="dark" text="Creating..." /> : null}

              <div className="d-flex align-items-center justify-content-between mt-5">
                <button
                  type="button"
                  className="header-btn text-bid border-bid"
                  onClick={() =>
                    setSelectedSteps(STEP.STEP_01)
                  }
                >
                  <span className="mr-3 transform-180">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="8"
                      height="12"
                      viewBox="0 0 8 12"
                      fill="none"
                    >
                      <path
                        d="M4.97633 6.00058L0.851562 1.87577L2.03007 0.697266L7.33341 6.00058L2.03007 11.3038L0.851562 10.1253L4.97633 6.00058Z"
                        fill="#09121F"
                      />
                    </svg>
                  </span>
                  Back
                </button>
                <button
                  type="submit"
                  className="header-btn text-white bg-bid border-bid mr-0 position-relative"
                >
                  Next
                  {imageUploadLoading ? (
                    <i className="fa fa-spinner small-spinner ml-3" />
                  ) : exportsettingsloading ? (
                    <i className="fa fa-spinner small-spinner ml-3" />
                  ) : (
                    <span className="ml-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="8"
                        height="12"
                        viewBox="0 0 8 12"
                        fill="none"
                      >
                        <path
                          d="M4.97633 6.00058L0.851562 1.87577L2.03007 0.697266L7.33341 6.00058L2.03007 11.3038L0.851562 10.1253L4.97633 6.00058Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                  )}
                </button>
              </div>
            </>
          ) : null}
        </form>
        {selectedSteps === STEP.STEP_04 ? (
          <>
            <div className="successfully-brand-created-div">
              <div>
                <img src={SuccessIMG} alt="" />
                <p className="f-14 inter font-weight-500 mb-0">Well Done!</p>
                <p className="f-14 inter font-weight-light">
                  Brand created Successfully
                </p>
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-end mt-5">
              <button
                className="header-btn text-white bg-bid border-bid mr-0"
                onClick={() => toggle()}
              >
                All Brands
                <span className="ml-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="8"
                    height="12"
                    viewBox="0 0 8 12"
                    fill="none"
                  >
                    <path
                      d="M4.97633 6.00058L0.851562 1.87577L2.03007 0.697266L7.33341 6.00058L2.03007 11.3038L0.851562 10.1253L4.97633 6.00058Z"
                      fill="white"
                    />
                  </svg>
                </span>
              </button>
            </div>
          </>
        ) : null}
      </MDBModalBody>
    </MDBModal>
  );
};

export default AddbrandAdmin;
